import { mediaQueries } from '@centivo/react-components'
import styled from 'styled-components'

import { ContentSection } from 'src/refactor/structure'

import { useGlobalState } from 'src/context/global'

const HeroSectionTag = styled(ContentSection)`
  display: grid;
  grid-template-columns: 100%;
  justify-content: space-between;

  margin-top: 3rem;
  margin-bottom: 2.5rem;

  @media ${mediaQueries.mobile} {
    margin-top: 1.5rem;
    margin-bottom: 2rem;
  }

  & > div {
    justify-content: center;

    h2 {
      font-size: 3.5rem;
      font-weight: 500;
      line-height: 3.5rem;

      color: ${({ theme }) => theme.palette.brand.darkGreen};

      max-width: 70rem;

      text-align: center;

      margin-left: auto;
      margin-right: auto;

      margin-bottom: 2rem;

      @media ${mediaQueries.mobile} {
        font-size: 2.5rem;
        font-weight: 500;
        line-height: 2.5rem;

        text-align: left;

        margin-bottom: 1.25rem;

        max-width: 100%;
      }
    }

    p {
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5rem;

      color: #212121;

      max-width: 42rem;

      text-align: center;

      margin-left: auto;
      margin-right: auto;

      @media ${mediaQueries.mobile} {
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 1.5rem;

        text-align: left;

        max-width: 100%;
      }
    }
  }
`

export const HeroSectionSlice: React.FC = () => {
  const [{ appConfig }] = useGlobalState()

  const { headerText } = appConfig

  return (
    <HeroSectionTag>
      <div>
        <h2>{headerText}</h2>
        <p>
          The Centivo Network is built around trusted, quality providers proven
          to deliver top results for their patients. The Centivo Network
          includes all the doctors and specialists you may need, including
          virtual options. Please contact us if you need help finding a certain
          type of provider near you.
        </p>
      </div>
    </HeroSectionTag>
  )
}
